var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar",style:({ '--size': _vm.size + 'px' })},[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar}}):_c(_setup.name_comp,{attrs:{"name":_vm.name,"length":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }